import { styled } from 'linaria/react';

export const FormContainer = styled.div<{ noTopMargin: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  height: 100%;
  margin-top: ${props => (props.noTopMargin ? '0' : 'var(--space-200)')};

  @media (max-width: 768px) {
    gap: var(--space-250);
  }
`;

export const ParamsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CalculationFormRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--space-500);

  & > div {
    max-width: 548px;
    @media (max-width: 1024px) {
      max-width: 100%;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
    & > div {
      max-width: 100%;
    }
  }
`;

export const CalculationFormColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
`;

export const CalculationFormColumnRight = styled.div`
  display: flex;
  flex-direction: column;

  @media (--to-tablet) {
    position: relative;
    bottom: var(--space-200);
    margin-top: auto;
  }
`;
